import React from 'react';
import { useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from 'src/componets/Pagination';

import '../style.scss';
import { EntityId } from "@reduxjs/toolkit";
import Card from "../../../mine_craft/Banners/_partials/_Card";
import { selectBannerEntities, selectBannerIds } from "../../../../store/mine_craft/bannersSlice";
import { selectUserEntities } from "../../../../store/mine_craft/usersSlice";
import Edit from "../Edit";

interface propsInterface {
  limit: number;
  pagination: boolean;
}

const _List = ({ limit, pagination }: propsInterface) => {
  const count  = useAppSelector(state => state.mineCraft.banners.count);
  const error  = useAppSelector(state => state.mineCraft.banners.error);
  const status = useAppSelector(state => state.mineCraft.banners.status);
  const ids = useAppSelector(selectBannerIds);
  const banners = useAppSelector(selectBannerEntities);
  const users = useAppSelector(selectUserEntities);

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  const renderBanner = (id: EntityId) => {
    const banner = banners[id];

    if (!banner) {
      return;
    }

    const user = banner.user_id ? users[banner.user_id] : undefined;

    return <Card banner={banner} user={user} key={`banner-${id}`} />;
  }

  return (
    <>
      {ids && ids.map(renderBanner)}

      {pagination && <Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
